import { AustralianState } from '@urbanx/agx-ui-components';
import GenerationStatus from '../GenerationStatus';

interface SalesContractGeneratingProps {
  generationStatus: GenerationStatus;
  state?: AustralianState;
  generatingText?: string;
  completeText?: string;
}

const GeneratingHeaderTextPdf = {
  [AustralianState.QLD]: 'Generating Contract',
  [AustralianState.NSW]: 'Generating Sales Advice',
};

const SalesContractGenerating = ({
  generationStatus,
  state,
  generatingText,
  completeText,
}: SalesContractGeneratingProps) => {
  if (generationStatus === GenerationStatus.Generating) {
    return generatingText ?? GeneratingHeaderTextPdf[state as keyof typeof GeneratingHeaderTextPdf];
  }

  if (generationStatus === GenerationStatus.Generated) {
    return completeText ?? 'Complete';
  }
};

export default SalesContractGenerating;
